import { ICampaign } from '../interfaces/models/campaign';

/** Statuses that accept new LD Contacts leads. Running campaigns are included on
 *  purpose: a campaign started with no leads sits idle until leads arrive, and the
 *  executors pick up newly enrolled leads on their next run. Canceled campaigns
 *  never run again, so they are excluded. */
const ENROLLABLE_STATUSES = ['draft', 'active', 'paused'];

/** Campaigns owned by the current user that can still receive LD Contacts leads. */
export function filterEnrollableCampaigns(
  campaigns: ICampaign[],
  userId: string | undefined,
): ICampaign[] {
  if (!userId) return [];
  const uid = String(userId);
  return campaigns.filter(
    c => ENROLLABLE_STATUSES.includes(c.status) && String(c.createdBy) === uid,
  );
}
